<template>
  <v-container class="py-10" fluid>
    <v-row align="center" justify="center">
      <h1>Coupons</h1>
    </v-row>
    <v-row align="center" justify="center">
      <v-col class="d-flex align-center justify-center" cols="12" sm="12" md="5" lg="5" xl="5">
        <v-text-field :disabled="loadingCoupons" prepend-icon="fa-search"
                      placeholder="Search by coupon name or user id..." v-model="search"/>
        <v-btn v-if="$store.state.desktop" @click="overlayAddCoupon = true" class="ml-5">
          Add Coupon <v-icon class="ml-2" small>fa-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="12" lg="10" md="11" sm="12" xl="10">
        <v-data-table :headers="headers" :items="items" :search="search" :loading="loadingCoupons" loading-text="Loading Coupons...">
          <template v-slot:item.discountPercentage="{ item }">
            <p class="my-0">{{ item.discountPercentage }}%</p>
          </template>
          <template v-slot:item.maxCount="{ item }">
            <p class="my-0">{{ item.maxCount }} coupons</p>
          </template>
          <template v-slot:item.userId="{ item }">
            <p class="my-0">{{ getUserInfo(item.userId) }}</p>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon @click="deleteCoupon(item)" class="icon" small>fa-trash</v-icon>
            <v-icon @click="showCouponLink(item)" class="icon" small>fa-link</v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-overlay v-model="overlayAddCoupon">
      <AddCoupon @created="createdCoupon" @close="overlayAddCoupon = false"/>
    </v-overlay>
    <v-overlay v-model="overlayDeleteCoupon">
      <DeleteCoupon @deleted="deletedCoupon" :coupon="selectedCoupon" @close="overlayDeleteCoupon = false"/>
    </v-overlay>
    <v-overlay v-model="overlayShowCouponLink">
      <ShowCouponLink :coupon="selectedCoupon" @close="overlayShowCouponLink = false"/>
    </v-overlay>
  </v-container>
</template>

<script>
import Repository from '../../repositories/payments';
import AddCoupon from "@/views/Coupons/components/AddCoupon";
import ShowCouponLink from "@/views/Coupons/components/ShowCouponLink";
import DeleteCoupon from "@/views/Coupons/components/DeleteCoupon";

export default {
  name: "Coupons",
  components: {DeleteCoupon, ShowCouponLink, AddCoupon},
  data() {
    return {
      loadingCoupons: false,
      headers: [
        {text: 'Coupon Name', value: 'couponName', align: 'left', sortable: true, filterable: true},
        {text: 'Discount', value: 'discountPercentage', align: 'left', sortable: true, filterable: false},
        {text: 'Max Count', value: 'maxCount', align: 'left', sortable: true, filterable: false},
        {text: 'Owner', value: 'userId', align: 'left', sortable: false, filterable: true},
        {text: 'Actions', value: 'actions', align: 'left', sortable: false, filterable: true},
      ],
      items: [],
      search: '',

      selectedCoupon: null,
      overlayAddCoupon: false,
      overlayDeleteCoupon: false,
      overlayShowCouponLink: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loadingCoupons = true;
      Repository.allCoupons().then((response) => {
        if (response.status < 400) {
          this.items = response.data;
          this.loadingCoupons = false;
        }
      });
    },
    createdCoupon() {
      this.init();
      this.overlayAddCoupon = false;
    },
    deletedCoupon() {
      this.init();
      this.overlayDeleteCoupon = false;
    },
    deleteCoupon(coupon) {
      this.selectedCoupon = coupon;
      this.overlayDeleteCoupon = true;
    },
    showCouponLink(coupon) {
      this.selectedCoupon = coupon;
      this.overlayShowCouponLink = true;
    },
    getUserInfo(userId) {
      let user = this.$store.state.users.find((user) => user.user.id === userId);
      return `${this.capitalize(user.user.firstName)} ${this.capitalize(user.user.lastName)}`
    },
    capitalize(string) {
      if(string === 'S.A.S.')
        return string;
      return `${string[0].toUpperCase()}${string.slice(1, string.length).toLowerCase()}`;
    },
  }
}
</script>

<style scoped>

</style>
